import { Box, Grid, Typography } from "@material-ui/core";
import { getUserInfo } from "../../../../../../utilities/storage";
import CaseItem from "./CaseItem";
const CaseList = ({ loading, data, classes }) => {
  const userInfo = getUserInfo();
  return (
    <Box className={classes.tabPanelContainer}>
      {loading ? (
        <Typography>Loading Cases...</Typography>
      ) : data && data.count === 0 ? (
        <Typography>No cases available</Typography>
      ) : (
        <Grid container spacing={2}>
          {data?.rows?.map((caseItem) => (
            <CaseItem
              key={caseItem.id}
              caseItem={caseItem}
              doctorId={userInfo?.id}
            />
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default CaseList;
